import styled, { keyframes } from 'styled-components';

const slideUp = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// Animação para as linhas da tabela aparecendo
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const Container = styled.div`
  width: 100%;

  @media (max-width: 1024px) {
    padding: 1rem;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  h1 {
    margin-left: 1rem;
    font-family: 'RedHatDisplay-ExtraBold';
    font-size: 2.2rem;
    color: #1e88e5;
  }

  span {
    margin-left: 0.5rem;
    font-size: 1rem;
    color: #323232;
  }

  .header-comunity {
    display: flex;
    align-items: center;
  }

  .primary-button {
    margin-left: auto;
    padding: 0.5rem 1rem;
    border-radius: 0.5rem;
  }

  @media (max-width: 580px) {
    h1 {
      margin-left: 0.81rem;
      font-family: 'RedHatDisplay-ExtraBold';
      font-size: 2.2rem;
      color: #1e88e5;
    }

    span {
      margin-left: 0.5rem;
    }

    .header-comunity {
      flex-direction: column;
      align-items: center;
    }

    .primary-button {
      font-size: 0.9rem;
      margin-left: auto;
      padding: 0.5rem 1rem;
      border-radius: 0.5rem;
    }
  }
`;

export const TitlePanel = styled.div`
  display: flex;
  align-items: center;
`;

export const Content = styled.div`
  display: flex;
  background: #fff;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  border: 1px solid #e0e0e0;

  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;

export const RankingUserSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 50%;

  @media (max-width: 1024px) {
    flex-direction: row;
    width: 100%;
  }
`;

export const TopUsers = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 4rem;
`;

export const PartyRanking = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  &.hidden-podium {
    opacity: 0;
    transform: translateY(50px);
  }

  &.animate-podium {
    animation: ${slideUp} 0.7s ease-out forwards;
  }

  &.animate-delay-1 {
    animation-delay: 0.2s;
  }

  &.animate-delay-2 {
    animation-delay: 0.4s;
  }

  @media (max-width: 1024px) {
    svg {
      width: 15rem;
    }
  }

  @media (max-width: 720px) {
    svg {
      width: 12rem;
    }
  }

  @media (max-width: 712px) {
    svg {
      width: 11rem;
    }
  }

  @media (max-width: 472px) {
    svg {
      width: 9rem;
    }
  }
  @media (max-width: 375px) {
    svg {
      width: 8rem;
    }
  }
`;

export const Avatar = styled.div<{ $color: string }>`
  > img {
    width: 6.66rem;
    height: 6.66rem;
    padding: 0.2rem;
    object-fit: cover;
    border-radius: 50%;
    border: 3px solid ${props => props.$color || '#ff9800'};
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin: 0.5rem 0.5rem;

  h2 {
    font-family: 'RedHatDisplay-Bold';
    font-size: 1.2rem;
    color: #323232;
  }

  p {
    font-family: 'RedHatDisplay-Regular';
    font-size: 0.9rem;
    color: #757575;
  }
`;

export const Podium = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  position: relative;
`;

export const Points = styled.div`
  position: absolute;
  top: 2.5rem;
  left: 50%;
  transform: translateX(-50%);
  font-family: 'RedHatDisplay-Bold';
  font-size: 1rem;
  color: #323232;
  margin-bottom: 0.5rem;
`;

export const RankingTableSection = styled.div`
  display: flex;
  flex-direction: column;
  padding: 1rem;
  border-left: 1px solid #e0e0e0;
  margin-left: 1rem;
  width: 50%;

  @media (max-width: 1024px) {
    border-top: 1px solid #e0e0e0;
    margin-top: 1rem;
    border-left: 0;
    margin-left: 0;
    width: 100%;
  }
`;

export const RankingTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #323232;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
`;

export const TableHeader = styled.thead`
  background-color: #f5f5f5;

  th {
    padding: 1rem;
    text-align: left;
    font-family: 'RedHatDisplay-Bold';
    color: #323232;
  }
`;

export const TableBody = styled.tbody`
  tr {
    border-bottom: 1px solid #eee;
    transition: background-color 0.2s;

    &:hover {
      background-color: #f9f9f9;
    }

    &:last-child {
      border-bottom: none;
    }
  }

  tr.hidden-row {
    opacity: 0;
    transform: translateY(10px);
  }

  tr.animate-row {
    animation: ${fadeIn} 0.5s ease-out forwards;
  }

  // Adicionar delays para cada linha
  tr.animate-delay-3 {
    animation-delay: 0.6s;
  }
  tr.animate-delay-4 {
    animation-delay: 0.7s;
  }
  tr.animate-delay-5 {
    animation-delay: 0.8s;
  }
  tr.animate-delay-6 {
    animation-delay: 0.9s;
  }
  tr.animate-delay-7 {
    animation-delay: 1s;
  }
  tr.animate-delay-8 {
    animation-delay: 1.1s;
  }
  tr.animate-delay-9 {
    animation-delay: 1.2s;
  }
  tr.animate-delay-10 {
    animation-delay: 1.3s;
  }

  td {
    padding: 0.5rem;
    font-family: 'RedHatDisplay-Regular';
    color: #323232;
    font-size: 0.9rem;
    text-align: center;
  }
`;

export const Position = styled.div<{ $position: number }>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: ${({ $position }) => ($position <= 10 ? '#323232' : '#757575')};
  font-family: 'RedHatDisplay-Bold';
  font-size: 1rem;
  text-align: center;
`;

export const UserCell = styled.td`
  display: flex;
  align-items: center;
  gap: 1rem;

  img {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    object-fit: cover;
  }

  div {
    display: flex;
    flex-direction: column;

    h3 {
      margin: 0;
      font-family: 'RedHatDisplay-Bold';
      font-size: 0.9rem;
      color: #323232;
    }

    p {
      margin: 0;
      font-family: 'RedHatDisplay-Regular';
      font-size: 0.8rem;
      color: #757575;
    }
  }
`;

export const PointsCell = styled.td`
  font-family: 'RedHatDisplay-Bold';
  text-align: center;
`;
